import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { OptionsService } from '../../options/services/options.service'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { IOptionsResponse } from '../../../common/common.types'
import { setHeadConciousnessOptions } from '../store/options.actions'

export function* getHeadConciousnessOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)

  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getHeadConciousnessOptions])
    const { entity } = response
    yield put(setHeadConciousnessOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getHeadConciousnessOptions() error: ${e}`))
  }
}

export function* getHeadConciousnessOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getHeadConciousnessOptions)
}
